export default __webpack_public_path__ + "assets/media/FEMI-Telehealth-Incoming_Call.2cc889e.mp3";